<template>
  <div>
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form :inline="true" :model="params" class="demo-form-inline"  label-width="80px">
          <el-form-item label="合同编号">
            <el-input v-model.trim="params.contractNumber" placeholder="合同编号" />
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model.trim="params.customerName" placeholder="客户姓名" />
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model.trim="params.phoneNumber" placeholder="手机号码" />
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input v-model.trim="params.merchantName" placeholder="商户名称" />
          </el-form-item>
          <el-form-item label="操作人">
            <el-input v-model.trim="params.operator" placeholder="操作人" />
          </el-form-item>
          <el-form-item label="产品类型">
            <el-select v-model.trim="params.productType" placeholder="产品类型">
              <el-option
                v-for="dict in productList"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型">
            <el-select v-model.trim="params.businessType" placeholder="业务类型">
              <el-option
                v-for="dict in businessTypeList"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="机构">
            <el-select v-model.trim="params.institutionCode" placeholder="机构">
              <el-option
                v-for="dict in fdOrgList"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select v-model.trim="params.applyChannel" placeholder="渠道">
              <el-option value="1" label="申城" />
              <el-option value="2" label="渠道2" />
            </el-select>
          </el-form-item>
          <el-form-item label="账龄">
            <el-select v-model.trim="params.accountsAge" placeholder="账龄">
              <el-option
                v-for="dict in fdAccountsAgeList"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFun">导出</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { exportOverdueForm } from '@/api/reportExport'
import { getDictionaryList } from '@/api/manage'

export default {
  name: 'download',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      params: {},
      fdAccountsAgeList: [],
      fdOrgList: [],
      businessTypeList: [],
      productList: [],
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  async created() {
    // 账龄
    const fdAccountsAgeRes = await getDictionaryList('fd_accountsAge')
    fdAccountsAgeRes.data.map((item) => {
      this.fdAccountsAgeList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    // 机构
    const fdOrgRes = await getDictionaryList('fd_org')
    fdOrgRes.data.map((item) => {
      this.fdOrgList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    // 业务类型
    const fdBusinessTypeRes = await getDictionaryList('fd_business_type')
    fdBusinessTypeRes.data.map((item) => {
      this.businessTypeList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    // 产品类型
    const profuctRes = await getDictionaryList('product_type')
    profuctRes.data.map((item) => {
      this.productList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
  },
  methods: {
    /**
     * 导出
     */
    async exportFun() {
      this.params.userId = this.currentUser.id
      const exportOverdueFormRes = await exportOverdueForm(this.params)
      this.$message.success(exportOverdueFormRes.data)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-section {
  margin-top: 20px;
}
</style>
